import React, { useMemo } from "react";
import "./Home.css";
import "font-awesome/css/font-awesome.min.css";

import { Link } from "react-router-dom";
import ImageSlider from "../Components/ImageSlider.jsx";
import about_img from "./images/about_img.jpg";
import { useLocale } from "../context/LocaleContext";
import { paths } from "../routes/paths";
import { orthoPagePath } from "../data/orthoMenuPages";
import { translations, DEFAULT_LOCALE } from "../i18n/translations";

const Home = () => {
  const { locale, t } = useLocale();
  const faqItems = useMemo(() => {
    const loc = locale === "en" ? "en" : DEFAULT_LOCALE;
    return translations[loc].home.faqItems || [];
  }, [locale]);

  return (
    <>
      <section id="home">
        <div className="slider_container page-shell">
          <div className="slider-images">
            <div className="slider_image">
              <ImageSlider />
            </div>

            <div className="front_container">
              <div className="front_page_info home_hero home_hero--cover">
                <h1 className="home_hero_title">
                  <span className="home_hero_title_top">{t("home.titleTop")}</span>
                  <span className="home_hero_title_bottom">{t("home.titleBottom")}</span>
                </h1>

                <p className="home_hero_lead">{t("home.lead")}</p>

                <p className="home_hero_lead home_hero_lead--secondary">
                  {t("home.leadSecondaryPrefix")}{" "}
                  <strong>{t("home.kwOrthodontics")}</strong>,{" "}
                  <strong>{t("home.kwBraces")}</strong>{" "}
                  {t("home.leadSecondaryOr")}{" "}
                  <strong>{t("home.kwAligners")}</strong>?
                </p>

                <ul className="home_hero_trust" aria-label={t("home.trustAria")}>
                  <li>
                    <i className="fa fa-check-circle" aria-hidden="true" />
                    {t("home.trustBraces")}
                  </li>
                  <li>
                    <i className="fa fa-check-circle" aria-hidden="true" />
                    {t("home.trustOrtho")}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="clinic_container">
          <div className="clinic_info">
            <div className="basic_info" id="info_01">
              <h2>{t("home.card1Title")}</h2>
              <p>{t("home.card1Text")}</p>
              <Link to={orthoPagePath("metalBraces")} className="home_clinic_hashlink">
                <div className="transperent_btn">{t("home.card1Cta")}</div>
              </Link>
            </div>
            <div className="basic_info" id="info_02">
              <h2>{t("home.card2Title")}</h2>
              <p>{t("home.card2Text")}</p>
              <Link to={orthoPagePath("invisalign")} className="home_clinic_hashlink">
                <div className="transperent_btn">{t("home.card2Cta")}</div>
              </Link>
            </div>
            <div className="basic_info" id="info_03">
              <h2>{t("home.card3Title")}</h2>
              <p>{t("home.card3Text")}</p>
              <Link to={paths.reservas} className="home_clinic_hashlink">
                <div className="transperent_btn" id="tr_btn_01">
                  {t("home.card3Cta")}
                </div>
              </Link>
            </div>
          </div>
        </div>

        <div className="home_emergency_banner clinic_container">
          <Link to={paths.emergency} className="home_emergency_banner_link">
            <span className="home_emergency_banner_kicker">
              {t('home.emergencyBannerTitle')}
            </span>
            <span className="home_emergency_banner_text">
              {t('home.emergencyBannerText')}
            </span>
            <span className="home_emergency_banner_cta">
              {t('home.emergencyBannerCta')}
            </span>
          </Link>
        </div>

        <div className="home_faq_wrap clinic_container">
          <article className="home_faq_block">
            <div className="home_faq_block_content">
              <h2 className="home_faq_heading">{t("home.faqHeading")}</h2>
              <p className="home_faq_intro">{t("home.faqIntro")}</p>
              <div className="home_faq_list" aria-label={t("home.faqAria")}>
                {faqItems.map((item) => (
                  <details key={item.q} className="home_faq_item">
                    <summary className="home_faq_question">{item.q}</summary>
                    <p className="home_faq_answer">{item.a}</p>
                  </details>
                ))}
              </div>
              <Link to={paths.reservas} className="home_faq_cta">
                {t("home.faqCta")}
              </Link>
            </div>
            <div className="home_faq_block_media">
              <img
                src={about_img}
                alt={t("about.imageAlt")}
                width={500}
                height={500}
                className="home_faq_block_img"
                loading="lazy"
                decoding="async"
              />
            </div>
          </article>
        </div>
      </section>
    </>
  );
};

export default Home;
